import utils from '@eitje/utils'
import {Text} from '../text'

export const ExternalLink = ({children, t, tabIndex, to, target = '_blank', onClick, className, disabled, style}) => {
	const classNameOverride = utils.makeCns(className, 'link', 'eitje-link', disabled && 'disabled')

	const isRawText = typeof children === 'string' || typeof children === 'number' || Boolean(t)
	let content = children
	if (isRawText) {
		content = (
			<Text t={t} hyperlink={!disabled}>
				{children}
			</Text>
		)
	}

	if (disabled)
		return (
			<div className={classNameOverride} style={{display: 'inline-block', ...style}}>
				{content}
			</div>
		)

	return (
		<a target={target} tabIndex={tabIndex} rel="noreferrer" href={to} className={classNameOverride} onClick={onClick} style={style}>
			{content}
		</a>
	)
}
